<div class="stepper">
    <div class="steps">
        <div *ngFor="let step of steps; let i = index" class="step" [class.active]="i === currentStep"
            [class.completed]="i < currentStep">
            <div class="circle">
                <span *ngIf="i < currentStep" class="tick">&#10003;</span>
                <span *ngIf="i >= currentStep">{{ i + 1 }}</span>
            </div>
            <div class="label">{{ step.label }}</div>
        </div>
    </div>
    <div class="content">
        <ng-container *ngIf="currentStep < steps.length">
            <ng-container *ngTemplateOutlet="steps[currentStep].content"></ng-container>
        </ng-container>
    </div>
    <div class="controls">
        <ng-container *ngTemplateOutlet="buttonLayout[0].content"></ng-container>
    </div>
</div>